import dayjs from 'dayjs';
import { openNotification } from 'swfrontend/COMS/NotificationMessageMapping';


export const SUPPLIER_FEEDBACK_BASE_API_PATH = '/supplier-feedback'
export const ALL_CLAIM_COLUMN_DEFS = [
    {
      headerName: "Id",
      width: 70,
      field: "id",
      editable: false,
      headerCheckboxSelection: true,
      checkboxSelection: true,
      cellRenderer: "MaterialListCellButton",
      primarykeyfield: true,
    },
    {
      headerName: "Vendor Name",
      width: 150,
      field: "contractor_name",
      editable: false
    },
    {
      headerName: "Contract Date",
      width: 80,
      field: "contract_date",
      editable: false
    },
    // {
    //   headerName: "Vendor Address",
    //   width: 150,
    //   field: "contractor_address",
    //   editable: false
    // },
    {
      headerName: "Contract Reference",
      width: 70,
      field: "contract_reference",
      editable: false
    },
    {
      headerName: "Project",
      width: 70,
      field: "project_details",
      editable: false
    },
    {
      headerName: "Status",
      width: 70,
      field: "status",
      editable: false
    },
    // {
    //   headerName: "Contract Price",
    //   width: 80,
    //   field: "contract_price",
    //   editable: false
    // },
    // {
    //   headerName: "Payment Claim on Submission",
    //   width: 80,
    //   field: "payment_claim_on_submission",
    //   editable: false
    // },
    // {
    //   headerName: "Amount of Work Done on Submission",
    //   width: 80,
    //   field: "percent_work_done_on_submission",
    //   editable: false
    // },
    // {
    //   headerName: "Payment Pending with AMNS",
    //   width: 80,
    //   field: "payment_pending_with_amns",
    //   editable: false
    // },
    // {
    //   headerName: "Work Done without Claim Submission",
    //   width: 80,
    //   field: "percent_work_done_without_claim_submission",
    //   editable: false
    // },
    {
      headerName: "Start Date",
      width: 80,
      field: "contract_start_date",
      editable: false
    },
    {
      headerName: "End Date",
      width: 80,
      field: "contract_end_date",
      editable: false
    },
    // {
    //   headerName: "Claim Details",
    //   width: 100,
    //   field: "details",
    //   editable: false
    // },
    // {
    //   headerName: "Claim Support Clause",
    //   width: 100,
    //   field: "support_clauses",
    //   editable: false
    // },
    // {
    //   headerName: "Claim Value",
    //   width: 80,
    //   field: "claim_value",
    //   editable: false
    // },
    // {
    //   headerName: "Claim Upto Date",
    //   width: 80,
    //   field: "upto_date",
    //   editable: false
    // },
    // {
    //   headerName: "Claim Reason",
    //   width: 80,
    //   field: "reason",
    //   editable: false
    // }
  ]
  

  export const formatDateTime = (dateTime, format = "") => {
    if (format.length > 1){
      format = "YYYY-MM-DD HH:mm"
    }
    if (dateTime.contains("T")){
      dateTime.replace("T", " ")
    }
    return dayjs(dateTime).format(format)
  }


export  const beforeUpload = (file) => {

  const allowedExtensions = [
    'doc', 'docx',  // Word
    'pdf',          // PDF
    'jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff', 'svg',  // Images
    'eml', 'msg', 'pst', 'ost',  // Emails
    'xls', 'xlsx', 'csv'  // Excel
  ]

    const maxSizeInMB = 15; // Maximum file size in MB

    // Get file extension
    const fileExtension = file.name.split('.').pop().toLowerCase();

    // Validate file size
    const isSizeValid = file.size / 1024 / 1024 < maxSizeInMB;

    if (!isSizeValid) {
      openNotification("error", "Error", `${file.name} size exceeds ${maxSizeInMB}MB limit.`);
      return false;
    }

    // Validate file extension
    if (!allowedExtensions.includes(fileExtension)) {
      openNotification("error", "Error", `${file.name} doesn't have correct file extension`);
      return false;
    }

    // File is valid
    return true;
  }

export const ACCEPT_FILE_TYPES="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf,image/jpeg,image/png,image/gif,image/bmp,image/tiff,image/svg+xml,message/rfc822,application/vnd.ms-outlook,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"

export const NEW_UPDATE_FILE_KEYS = ["file", "letter_file"];